import type { WebCompatibleWebViewProps } from '@/src/common/components/WebCompatibleWebView/WebCompatibleWebViewProps'
import { type ComponentRef, useEffect, useRef } from 'react'
import { View } from 'react-native'

export function WebCompatibleWebView({ onMessage, ...props }: WebCompatibleWebViewProps) {
  const ref = useRef<ComponentRef<'iframe'>>(null)

  useEffect(() => {
    const handleMessage = ((event) => {
      if (ref.current && event.source === ref.current.contentWindow) {
        // only call the onMessage handler if this event is coming specifically from the iframe that this component instance renders
        // on web, `postMessage` can come from anywhere, e.g. multiple other `iframe`s or even web workers
        onMessage?.(event)
      }
    }) satisfies Parameters<typeof window.addEventListener<'message'>>[1]

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [onMessage])

  return (
    <View style={props.containerStyle}>
      <View style={[{ height: '100%', width: '100%' }, props.style]} testID={props.testID}>
        <iframe
          ref={ref}
          style={{ height: '100%', width: '100%', border: 'none' }}
          src={props.source}
          onError={props.onError}
          onLoad={props.onLoad}
          {...props.iframeProps}
        />
      </View>
    </View>
  )
}
